import { autoinject, bindable, observable, computedFrom } from "aurelia-framework";
import { uniqBy, filter, includes } from "lodash";
import { AccountGroupStructure, IAccountGroupStructureAM, AccountStructure } from "../account-api";
import { NodeModel } from "../../../models/node-model";
import { ResourceService } from "../../../utils/resourceService";
import { IAccountSelectionModel } from "../../reporting/report-components/report-filters";
import { TreeNode } from "../../../components/tree-view/tree-node";

@autoinject
export class AccountGroupsSelect {
	@bindable accountGroups: AccountGroupStructure[];
	@bindable onSelectionChange: (selectionModel: any) => void;
	@bindable preSelectedItems: IAccountSelectionModel;
	accountClasses: NodeModel[] = [];

	selectedGroupCollection = [];

	constructor(private resource: ResourceService) { }

	selectedNodesChanged(values: AccountGroupStructure[], selectedNodes: Set<TreeNode>) {
		const selectionModel = {
			accounts: null,
			accountGroups: null,
			accountClasses: null
		};
		
		selectedNodes.forEach(node => {
			if(node.isSelected && !node.isIndeterminate) {
				/*
				 * nodeModel = AccountClass || AccountGroup || Account
				 * nodeModel.parent = AccountClass || AccountGroup 
				 * nodeModel.parent.parent = AccountClass 
				 */
				const nodeModel = node.current;
				switch(node.current.nodeType) {
					case 'AccountClass': selectionModel.accountClasses = [].concat(selectionModel.accountClasses || [], [nodeModel.id]);
						break;
					case 'AccountGroup': 
						if(!includes(selectionModel.accountClasses, nodeModel.parent.id)) {
							selectionModel.accountGroups = [].concat(selectionModel.accountGroups || [], [nodeModel.id]);
						}
						break;
					case 'Account': 
						if(!includes(selectionModel.accountGroups, nodeModel.parent.id) && !includes(selectionModel.accountClasses, nodeModel.parent.parent.id)) {
							selectionModel.accounts = [].concat(selectionModel.accounts || [], [nodeModel.id]);
						}
						break;
				}
			}
		});

		this.onSelectionChange({ selectionModel });
	}

	private attachPreSelection() {
		this.selectedGroupCollection = [].concat([], this.preSelectedItems.accountClasses, this.preSelectedItems.accountGroups, this.preSelectedItems.accounts);
	}

	private createStructure() {
		this.accountClasses = uniqBy(this.accountGroups, (group: AccountGroupStructure) => group.accountClass)
			.map((group: AccountGroupStructure) => group.accountClass)
			.map((ac, index) => {
				const node = Object.assign(new NodeModel(this.resource.getResource(`AccountClass_${ac}`), index, null, ac), { nodeType: 'AccountClass' });

				node.children = this.accountGroups
					.filter((group: AccountGroupStructure) => group.accountClass === ac)
					.map(item => {
						item.parent = node;
						return item;
					});
				
				return node;
			});
	}

	bind() {
		this.createStructure();

		if (this.preSelectedItems) {
			this.attachPreSelection();
		}
	}
}
